(function Module() {
	'use strict';

	mySynch.controller('VideoListController', [
		'$scope',
		function VideoListController($s) {
			$s.currentVideo = null;
			$s.videos = [
				{
					name: 'What is mySYNCH',
					code: 'lwZ0u5_GKPs',
					language: 'english'
				},
				{
					name: 'Strategies for nonpregnancy diagnosis in dairy cows',
					code: 'lNeJqj286dc',
					language: 'english'
				},
				{
					name: 'An update on repro technologies and protocols',
					code: 'Er7kMZMtZOo',
					language: 'english'
				},
				{
					name: 'Chapter 1 - Introduction',
					code: 'JEKU-IfTPRc',
					language: 'english'
				},
				{
					name: 'Chapter 2 - Anatomy and Physiology',
					code: 'Liu_S7MPRyA',
					language: 'english'
				},
				{
					name: 'Chapter 3 - The Estrous Cycle',
					code: 'UOvwN90bYUA',
					language: 'english'
				},
				{
					name: 'Chapter 4 - The Science of Fertility Programs',
					code: 'iSxwGjgaGJg',
					language: 'english'
				},
				{
					name: 'Chapter 5 - Fertility Program Practice & Measures',
					code: 'Lkrcy9l8pSg',
					language: 'english'
				},
				{
					name: 'Chapter 6 - Optimizing Fertility Programs',
					code: 'I3yF87FniuM',
					language: 'english'
				},
				{
					name: 'Capitulo 1 - Introduccion',
					code: 'H3BU-JgcJVo',
					language: 'spanish'
				},
				{
					name: 'Capitulo 2 - Anatomía y Fisiología',
					code: 'fg0tjuHDc6U',
					language: 'spanish'
				},
				{
					name: 'Capitulo 3 - El Ciclo Estral',
					code: 'G-dDcMuAcsY',
					language: 'spanish'
				},
				{
					name: 'Capitulo 4 - La Ciencia de los Programas de Cría',
					code: '_egB6m25NNI',
					language: 'spanish'
				},
				{
					name: 'Capitulo 5 - Fertilidad y Medidas Prácticas Programa',
					code: 'nzlcgBqw5f0',
					language: 'spanish'
				},
				{
					name: 'Capitulo 6 - Optimizar los Programas de Fertilidad',
					code: 'INaGPo3xR9o',
					language: 'spanish'
				}
			];

			$s.showVideo = function showVideo(videoCode) {
				$s.currentVideo = _.find($s.videos, {code: videoCode});
				document.getElementById('videoPlayer').src = 'https://www.youtube.com/embed/' + videoCode + '?rel=0';
			};

			MSF.ready(function msfReady() {
				$s.showVideo(_.filter($s.videos, {language: 'english'})[0].code);
			});
		}
	]);
})();
